import { connect } from 'react-redux';
import { Tasklist } from 'modules/cm/pages/CaseDetailsPage/subPages';
import { RootState } from 'store/configureStore';
import { selectors } from '../store';
import { completeTask, setTaskAsNotApplicable, undoTask } from '../useCases';
import { getCase } from 'modules/cm/pages/CaseDetailsPage/hooks/useReduxCase';

const mapStateToProps = (state: RootState) => {
  return {
    caseId: getCase(state).identifier,
    completedTasks: selectors.getCompletedTasks(state),
    todoTasks: selectors.getTodoTasks(state),
  };
};

const mapDispatchToProps = {
  completeTask,
  setTaskAsNotApplicable,
  undoTask,
};

export default connect(mapStateToProps, mapDispatchToProps)(Tasklist);
